// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import type { Icon } from 'iconsax-react';

const StatusCheckboxIcon: Icon = ({ size = 16, color, variant: _variant, className, style, ...rest }) => {
  const fill = color || 'currentColor';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...rest}
    >
      <path d="M9.16667 14.3333H5.16667C1.54667 14.3333 0 12.7867 0 9.16667V5.16667C0 1.54667 1.54667 0 5.16667 0H9.16667C12.7867 0 14.3333 1.54667 14.3333 5.16667V9.16667C14.3333 12.7867 12.7867 14.3333 9.16667 14.3333ZM5.16667 1C2.09333 1 1 2.09333 1 5.16667V9.16667C1 12.24 2.09333 13.3333 5.16667 13.3333H9.16667C12.24 13.3333 13.3333 12.24 13.3333 9.16667V5.16667C13.3333 2.09333 12.24 1 9.16667 1H5.16667Z" fill={fill} />
      <path d="M6.21993 9.55274C6.0866 9.55274 5.95993 9.49941 5.8666 9.40607L3.97996 7.51941C3.78663 7.32607 3.78663 7.00607 3.97996 6.81274C4.17329 6.61941 4.49329 6.61941 4.68663 6.81274L6.21993 8.34607L9.6466 4.91941C9.83993 4.72608 10.1599 4.72608 10.3533 4.91941C10.5466 5.11275 10.5466 5.43275 10.3533 5.62608L6.57327 9.40607C6.47993 9.49941 6.35327 9.55274 6.21993 9.55274Z" fill={fill} />
    </svg>
  );
};

export { StatusCheckboxIcon };
